import React, { useEffect, useState } from "react";
import { NavigateNext, NavigateBefore } from "@mui/icons-material";
import "./PhotoGallery.css";

const PhotoGallery = ({ bgimage, setBgimage, images, isLoading, setIsLoading }) => {
  const [index, setIndex] = useState(0);
  const [showZoom, setShowZoom] = useState(false);
  const [zoomPosition, setZoomPosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    if (images?.length) {
      setIndex(0); // Reinicia el índice al cambiar las imágenes
      // console.log("HOLA")
      setBgimage(images[0]?.url?.secure_url); // Asegura la primera imagen del nuevo producto
      setIsLoading(false);
    }
  }, [images]);

  useEffect(() => {
    if (images?.length > 0) {
      console.log("HOLA")
      setBgimage(images[index]?.url?.secure_url); // Asegura la primera imagen del nuevo producto
    }
  }, [index]);
  

  const handleMouseMove = (e) => {
    const { left, top, width, height } = e.target.getBoundingClientRect();
    const x = ((e.pageX - left) / width) * 100;
    const y = ((e.pageY - top) / height) * 100;
    setZoomPosition({ x: x, y: y });
  };

  const ChangeThumbnail = (id) => {
    const newImage = images.find((item) => item.asset_id === id);
    setBgimage(newImage?.secure_url);
  };

  const checkNumber = (number) => {
    if (number > images?.length - 1) return 0;
    if (number < 0) return images?.length - 1;
    return number;
  };

  const nextPerson = () => {
    setIndex((index) => {
      let newIndex = index + 1;
      return checkNumber(newIndex);
    });
  };

  const prevPerson = () => {
    setIndex((index) => {
      let newIndex = index - 1;
      return checkNumber(newIndex);
    });
  };

  return (
    <div className="gallery-container">
      <div
        className="image-container"
        onMouseEnter={() => setShowZoom(true)}
        onMouseLeave={() => setShowZoom(false)}
        onMouseMove={handleMouseMove}
      >
        {!isLoading ? (
          <img src={bgimage} alt="main-image" className="main-image" />
        ): <p>Cargando...</p>}
        {showZoom && (
          <div
            className="zoom-lens"
            style={{
              left: `${zoomPosition.x}%`,
              top: `${zoomPosition.y}%`,
            }}
          />
        )}
      </div>

      {showZoom && (
        <div className="zoom-container">
          <img
            src={bgimage}
            alt="zoomed-image"
            className="zoomed-image"
            style={{
              transform: `translate(-${zoomPosition.x}%, -${zoomPosition.y}%) scale(1.3)`,
            }}
          />
        </div>
      )}

      <div className="navigation-controls">
        <NavigateBefore onClick={prevPerson} className="nav-arrow" style={{ width: "50px", height: "50px" }} />
        <NavigateNext onClick={nextPerson} className="nav-arrow" style={{ width: "50px", height: "50px" }} />
      </div>
    </div>
  );
};

export default PhotoGallery;